import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { setShowRequiredTasksOnly } from 'bundles/apex/deals/show/store/planner_filters/actions';
import ManagedInput from 'components/form/managed_input';

export function RequiredFilter({ showRequiredTasksOnly, setShowRequiredTasksOnly }) {
  return (
    <ManagedInput
      name="createTasks"
      type="checkbox"
      value={showRequiredTasksOnly}
      wrapperClassName="mr-3"
      onValueChange={setShowRequiredTasksOnly}
    >
      Show Required Only
    </ManagedInput>
  );
}

RequiredFilter.propTypes = {
  setShowRequiredTasksOnly: PropTypes.func.isRequired,
  showRequiredTasksOnly: PropTypes.boolean,
};

const mapStateToProps = ({ plannerFilters: { required } }) => {
  return {
    showRequiredTasksOnly: required
  };
};

const mapDispatchToProps = {
  setShowRequiredTasksOnly
};

export default connect(mapStateToProps, mapDispatchToProps)(RequiredFilter);
